import { Flex } from '@blockanalitica/ui';
import RevenueProjected from './RevenueProjected';
import RevenueTillNow from './RevenueTillNow';

export default function RevenueSection() {
  return (
    <Flex
      flexDirection={['column', 'column', 'row']}
      gap={['m', 's']}
      alignItems={['stretch', 'stretch', 'flex-start']}>
      <RevenueTillNow />
      <RevenueProjected />
    </Flex>
  );
}
